/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Block from "../../atoms/layout/Block";

export function CardList({ items, Card, ctaCard, emptyPlaceholder }) {
    if (!Card || items.length === 0) {
        return <Block className="p-flex card-list grid row">
            <div>
                {emptyPlaceholder || null}
            </div>
        </Block>;
    }

    return (<Block className="p-flex card-list grid row">
        <Block className={"p-flex p-flex-wrap"}>
            { items && items.map((item, index) => (<Card key={"card-" + item.id + index} item={item} position={index + 1} />)) }
            { ctaCard || null }
        </Block>
    </Block>)
}

CardList.propTypes = {
    items: PropTypes.array,
    Card: PropTypes.func.isRequired,
    listSize: PropTypes.number,
    ctaCard: PropTypes.node,
};
